import { render } from "./CompanyList-Suppliers.vue?vue&type=template&id=730bc78a&ts=true"
import script from "./CompanyList-Suppliers.vue?vue&type=script&lang=ts"
export * from "./CompanyList-Suppliers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__